import { startErrorReporting } from '@/Support/errorReporting';

// Its own entry, loaded before app.ts (see app.blade.php), so Sentry is running before any of
// the app's chunks: in the build, app.ts's shared vendor chunks (vue, pinia, ark-ui) run before
// its own code, whatever order it imports them in. Not named sentry, since ad blockers may block that.
startErrorReporting();

window.__bootStage = 'started';
